import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { ContextPanelEl } from "common/widgets/context-panel";
import { ButtonEl } from "common/components/button";
import { ConfirmEl } from "common/components/confirm";
import { CreateEntityModalEl } from "common/widgets/create-entity-modal";
import { ButtonTheme } from "common/components/button/constants";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import { THEME } from "common/components/confirm/types";
import { QueryEntrySectionEl } from "common/query-builder/query-entry-section/panel";
import { RowLabelType } from "common/query-builder/query-entry-section/types";
import { Directions, PositioningStrategy } from "common/components/drop-menu/types";
import { CustomPropertyResourceType } from "common/report/stores/custom-properties";
import { BannerEl } from "common/components/banner";
import { BannerTheme, BannerType } from "common/components/banner/types";
import { MarkdownEl } from "common/components/markdown";
import { IncludeCustomPropertyType } from "common/query-builder/query-block/properties-menu/types";
import { EditorEl } from "./editor";
import { CustomPropertyHelpTextEl } from "./help-text";
const FieldErrorTooltip = (_ref) => {
  let {
    errors,
    field
  } = _ref;
  if (errors[field]) {
    return /* @__PURE__ */ jsx("div", { sel: ".custom-property-error-tooltip" }, /* @__PURE__ */ jsx(MarkdownEl, { sel: ".mp-tooltip-text", attrs: {
      text: errors[field]
    } }));
  }
  return null;
};
function renderUpsellButton(_ref2) {
  let {
    component,
    text,
    theme
  } = _ref2;
  return /* @__PURE__ */ jsx("div", { sel: ".upsell-button", "data-sentry-component": "renderUpsellButton", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top,
    size: DisplaySize.Medium
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, component.t("custom-property.upgrade-description")), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme,
    icon: "share"
  }, on: {
    click: component.helpers.openPricingUpsell
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, text));
}
export function template() {
  const {
    autocompleteOpen,
    autocompletePopup,
    currentAutocompleteLine,
    customProperty,
    errors,
    toCreate,
    toDelete,
    tooltipData
  } = this.state;
  const bannerText = this.getBannerText();
  return /* @__PURE__ */ jsx("div", { sel: ".custom-property-modal-wrapper", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, !toCreate ? /* @__PURE__ */ jsx(ModalEl, { sel: ".custom-property-modal", attrs: {
    open: this.attr("open"),
    "grow-to-content": true
  }, on: {
    change: this.helpers.modalStateChange
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header" }, /* @__PURE__ */ jsx("div", { sel: ".mp-card-header-title" }, this.helpers.getHeaderText())), /* @__PURE__ */ jsx("form", { sel: ".custom-property-body", class: {
    "for-behaviors": this.helpers.isBehavioralProperty()
  } }, bannerText && /* @__PURE__ */ jsx("div", { sel: ".custom-property-section" }, /* @__PURE__ */ jsx(BannerEl, { attrs: {
    theme: BannerTheme.Info,
    "body-text": bannerText,
    type: BannerType.Embedded
  } })), /* @__PURE__ */ jsx("div", { sel: ".custom-property-section" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label" }, this.t("custom-property.name-title")), /* @__PURE__ */ jsx(FieldErrorTooltip, { errors, field: "name" })), /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-container" }, /* @__PURE__ */ jsx("input", { sel: ".custom-property-section-input", on: {
    input: (ev) => this.helpers.updateName(ev.target.value)
  }, attrs: {
    autocomplete: "off",
    elref: "nameInput"
  }, props: {
    size: 50,
    type: "text",
    value: this.helpers.getName()
  }, class: {
    "custom-property-error": !!errors.name
  } }))), this.helpers.isPersisted() ? /* @__PURE__ */ jsx("div", { sel: ".custom-property-section" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label" }, this.t("custom-property.description-title"), /* @__PURE__ */ jsx("div", { sel: ".custom-property-description-tooltip" }, this.t("custom-property.description-optional")))), /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-container" }, /* @__PURE__ */ jsx("input", { sel: ".custom-property-section-input", on: {
    input: this.helpers.updateDescription
  }, props: {
    size: 50,
    type: "text",
    value: this.helpers.getDescription()
  } }))) : null, /* @__PURE__ */ jsx("div", { sel: ".custom-property-builder" }, this.helpers.isBehavioralProperty() ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".custom-property-section-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label" }, this.t("custom-property.condition-title"))), /* @__PURE__ */ jsx("div", { sel: ".custom-property-query-events-section" }, /* @__PURE__ */ jsx(QueryEntrySectionEl, { entries: this.helpers.getQueryEntries(), enableWorkspaceFilterRestrictions: this.attr("enable-workspace-filter-restrictions"), hideEditControls: true, includeCustomProperties: IncludeCustomPropertyType.PersistedOnly, disableDeleteEntry: true, projectId: this.attr("project-id"), rowLabelType: RowLabelType.None, metricsMode: true, rowLimit: 1, rowTypes: this.helpers.getBehavioralSelectorTypes(), eventAggregatorFunctions: this.helpers.getBehavioralAggregationMethods(), propertyAggregatorFunctions: this.helpers.getBehavioralAggregationMethods(), trackName: this.attr("track-name"), userId: this.attr("user-id"), workspaceId: this.attr("workspace-id"), onUpdate: this.helpers.handleQueryEventsSectionUpdate }))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".custom-property-flex-wrapper.custom-property-formula-flex-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-label.custom-property-formula-label" }, this.t("custom-property.formula-title")), /* @__PURE__ */ jsx("div", { sel: ".custom-property-tooltip", on: {
    click: this.helpers.tooltipClicked
  } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  } }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "max-width": "480px",
    placement: Placement.Right,
    clickable: "true"
  } }, this.t("custom-property.formula-tooltip"))), /* @__PURE__ */ jsx(FieldErrorTooltip, { errors, field: "displayFormula" })), /* @__PURE__ */ jsx(SelectEl, { sel: ".custom-property-example-menu", attrs: {
    elref: "insertExample",
    "menu-width": 160,
    sections: this.helpers.getExampleSections(),
    "selected-option": this.t("custom-property.insert-example"),
    "disable-search": true
  }, on: {
    change: this.helpers.handleInsertExample
  } })), /* @__PURE__ */ jsx("div", { sel: ".custom-property-input-area", class: {
    "custom-property-error": !!errors.displayFormula
  } }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-ace-wrapper", key: "ace-editor" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-border" }), this.isEditorReady() && /* @__PURE__ */ jsx(EditorEl, { attrs: {
    "all-data-groups": this.attr("all-data-groups"),
    "composed-properties": JSON.stringify(this.helpers.getComposedProperties()),
    "data-group-id": this.attr("data-group-id"),
    "display-formula": this.helpers.getDisplayFormula(),
    "event-names": this.attr("event-names"),
    "enable-workspace-filter-restrictions": this.attr("enable-workspace-filter-restrictions"),
    "show-borrowed-properties": this.attr("show-borrowed-properties"),
    "project-id": this.attr("project-id"),
    "resource-type": this.helpers.getResourceType(),
    "user-id": this.attr("user-id"),
    "workspace-id": this.attr("workspace-id"),
    "show-borrow-property-action": this.canUseBorrowedProperties() && this.helpers.getResourceType() === CustomPropertyResourceType.Events,
    elref: "ace-editor"
  }, on: {
    connect: this.helpers.handleEditorConnect,
    change: this.helpers.handleValueChange,
    autocompleteChange: this.helpers.handleEditorAutocompleteChange
  }, hook: {
    insert: this.helpers.handleEditorElementInsert
  } }), /* @__PURE__ */ jsx("div", { sel: ".custom-property-border" })), autocompletePopup ? /* @__PURE__ */ jsx(ContextPanelEl, { attrs: {
    placement: autocompleteOpen ? Directions.Right : Directions.Left,
    "force-placement": !autocompleteOpen,
    "always-expanded": true,
    "position-strategy": PositioningStrategy.Fixed
  }, params: {
    data: tooltipData,
    positionParent: autocompleteOpen ? autocompletePopup : currentAutocompleteLine
  } }) : null), /* @__PURE__ */ jsx("div", { sel: ".custom-property-info-tooltip" }, /* @__PURE__ */ jsx(CustomPropertyHelpTextEl, null))))), /* @__PURE__ */ jsx("div", { sel: ".custom-property-footer" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-flex-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".custom-property-action-wrapper" }, (() => {
    if (this.helpers.isPersisted()) {
      return /* @__PURE__ */ jsx(ButtonEl, { on: {
        click: this.helpers.setToDelete
      } }, this.t("common.delete"));
    } else if (!this.helpers.isBehavioralProperty() && !this.usesBorrowedProperty()) {
      if (this.helpers.isSavingRestricted()) {
        return renderUpsellButton({
          component: this,
          text: this.t("custom-property.upgrade-cta"),
          theme: ButtonTheme.Secondary
        });
      } else if (!this.attr("enable-workspace-filter-restrictions")) {
        return /* @__PURE__ */ jsx(ButtonEl, { attrs: {
          disabled: this.helpers.isSavingDisabled()
        }, on: {
          click: () => this.helpers.applyProperty(true)
        } }, this.t("common.save"));
      } else {
        return null;
      }
    } else {
      return null;
    }
  })())), /* @__PURE__ */ jsx(ButtonEl, { sel: ".custom-property-button.custom-property-cancel-button", attrs: {
    theme: ButtonTheme.Tertiary
  }, on: {
    click: this.helpers.closeModal
  } }, this.t("common.cancel")), this.helpers.isEdit() && this.helpers.isPersisted() ? this.helpers.isSavingRestricted() ? renderUpsellButton({
    component: this,
    text: this.t("custom-property.upgrade-cta-update"),
    theme: ButtonTheme.Primary
  }) : /* @__PURE__ */ jsx(ButtonEl, { sel: ".custom-property-button.custom-property-save-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: this.helpers.isSavingDisabled()
  }, on: {
    click: () => this.helpers.applyProperty(false)
  } }, this.t("common.save")) : this.usesBorrowedProperty() && this.helpers.isSavingRestricted() ? renderUpsellButton({
    component: this,
    text: this.t("custom-property.upgrade-cta"),
    theme: ButtonTheme.Primary
  }) : /* @__PURE__ */ jsx(ButtonEl, { sel: ".custom-property-button.custom-property-save-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: this.helpers.isSavingDisabled(),
    elref: "applyButton"
  }, on: {
    click: () => this.helpers.applyProperty(this.usesBorrowedProperty())
  } }, this.usesBorrowedProperty() ? this.t("common.save") : this.t("common.apply"))), /* @__PURE__ */ jsx(ConfirmEl, { attrs: {
    theme: THEME.DELETE,
    open: !!toDelete,
    closeable: true
  }, on: {
    change: (ev) => this.helpers.handleDeleteConfirmChange(ev.detail.state),
    submit: (ev) => {
      if (ev.detail.action === "confirm") {
        this.helpers.deleteProperty();
      }
    }
  } }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-title" }, this.t("custom-property.header.delete")), /* @__PURE__ */ jsx("div", { sel: ".mp-confirm-description" }, this.t("custom-property.delete-confirmation", {
    customPropertyName: customProperty.name
  }))))) : /* @__PURE__ */ jsx(CreateEntityModalEl, { attrs: this.helpers.buildCreateEntityModalAttrs(), on: {
    nameInput: (ev) => this.helpers.updateName(ev.detail.name),
    save: this.helpers.handleCreate,
    cancel: this.helpers.handleCancelCreate,
    saveAndShare: this.helpers.handleCreate
  }, props: {
    existingEntityNames: this.helpers.getPersistedCustomPropertyNames()
  } }));
}
